// extracted by mini-css-extract-plugin
module.exports = {"circle":"Progress_circle__BKyeI","container":"Progress_container__GyDN4","percentage":"Progress_percentage__14fbk","svg":"Progress_svg__3xn76"};